// Mock data for Harday UI

export const mockUsers = [
  {
    id: '1',
    name: 'Rahul Sharma',
    username: '@rahul_s',
    telegramId: '@rahulsharma',
    profilePic: 'https://images.unsplash.com/photo-1623594675959-02360202d4d6?crop=entropy&cs=srgb&fm=jpg&w=150&q=85',
    profileScore: 0,
    credits: 1250,
    streak: 5,
    totalPuzzlesSolved: 23,
    rightAnswers: 19,
    wrongAnswers: 4,
    totalFollowers: 20,
    poolWins: 0,
    downlineWins: 2,
    isActivated: true,
    isFirstVisit: false,
    referredBy: null,
    referrals: {
      active: 8,
      inactive: 12,
      total: 20
    }
  },
  {
    id: '2',
    name: 'Priya Patel',
    username: '@priya_p',
    telegramId: '@priyapatel',
    profilePic: 'https://images.unsplash.com/photo-1576558656222-ba66febe3dec?crop=entropy&cs=srgb&fm=jpg&w=150&q=85',
    profileScore: 2500,
    credits: 450,
    streak: 12,
    totalPuzzlesSolved: 67,
    rightAnswers: 58,
    wrongAnswers: 9,
    totalFollowers: 20,
    poolWins: 3,
    downlineWins: 1,
    isActivated: true,
    isFirstVisit: false,
    referredBy: '1',
    referrals: {
      active: 15,
      inactive: 5,
      total: 20
    }
  },
  {
    id: '3',
    name: 'Arjun Mehta',
    username: '@arjun_m',
    telegramId: '@arjunmehta',
    profilePic: 'https://images.pexels.com/photos/13422326/pexels-photo-13422326.jpeg?auto=compress&cs=tinysrgb&w=150',
    profileScore: 5000,
    credits: 890,
    streak: 20,
    totalPuzzlesSolved: 102,
    rightAnswers: 91,
    wrongAnswers: 11,
    totalFollowers: 33,
    poolWins: 5,
    downlineWins: 3,
    isActivated: true,
    isFirstVisit: false,
    referredBy: null,
    referrals: {
      active: 25,
      inactive: 8,
      total: 33
    }
  }
];

export const mockPreviousWinners = [
  {
    id: 'w1',
    userId: '2',
    name: 'Priya Patel',
    username: '@priya_p',
    telegramId: '@priyapatel',
    profilePic: 'https://images.unsplash.com/photo-1576558656222-ba66febe3dec?crop=entropy&cs=srgb&fm=jpg&w=150&q=85',
    date: '2026-01-09',
    profileScore: 2500,
    streak: 12,
    totalPuzzlesSolved: 67,
    rightAnswers: 58,
    wrongAnswers: 9,
    totalFollowers: 20,
    poolWins: 3,
    downlineWins: 1
  },
  {
    id: 'w2',
    userId: '3',
    name: 'Arjun Mehta',
    username: '@arjun_m',
    telegramId: '@arjunmehta',
    profilePic: 'https://images.pexels.com/photos/13422326/pexels-photo-13422326.jpeg?auto=compress&cs=tinysrgb&w=150',
    date: '2026-01-08',
    profileScore: 5000,
    streak: 20,
    totalPuzzlesSolved: 102,
    rightAnswers: 91,
    wrongAnswers: 11,
    totalFollowers: 33,
    poolWins: 5,
    downlineWins: 3
  },
  {
    id: 'w3',
    userId: '1',
    name: 'Sanya Gupta',
    username: '@sanya_g',
    telegramId: '@sanyagupta',
    profilePic: 'https://images.unsplash.com/photo-1623594675959-02360202d4d6?crop=entropy&cs=srgb&fm=jpg&w=150&q=85',
    date: '2026-01-07',
    profileScore: 1800,
    streak: 7,
    totalPuzzlesSolved: 34,
    rightAnswers: 28,
    wrongAnswers: 6,
    totalFollowers: 15,
    poolWins: 1,
    downlineWins: 0
  }
];


export const mockReferrals = [
  {
    id: 'ref1',
    name: 'Vikram Singh',
    username: '@vikram_s',
    profilePic: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&w=100&q=80',
    status: 'active',
    credits: 85,
    topupCredits: 85,
    refCredits: 0,
    joinedDate: '2026-01-02',
    puzzlesSolved: 14
  },
  {
    id: 'ref2',
    name: 'Neha Kapoor',
    username: '@neha_k',
    profilePic: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&w=100&q=80',
    status: 'active',
    credits: 220,
    topupCredits: 220,
    refCredits: 0,
    joinedDate: '2025-12-28',
    puzzlesSolved: 31
  },
  {
    id: 'ref3',
    name: 'Amit Verma',
    username: '@amit_v',
    profilePic: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&w=100&q=80',
    status: 'active',
    credits: 45,
    topupCredits: 45,
    refCredits: 0,
    joinedDate: '2026-01-05',
    puzzlesSolved: 8
  },
  {
    id: 'ref4',
    name: 'Deepika Rao',
    username: '@deepika_r',
    profilePic: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?crop=entropy&cs=srgb&fm=jpg&w=100&q=80',
    status: 'active',
    credits: 130,
    topupCredits: 130,
    refCredits: 0,
    joinedDate: '2025-12-20',
    puzzlesSolved: 22
  },
  {
    id: 'ref5',
    name: 'Karan Malhotra',
    username: '@karan_m',
    profilePic: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?crop=entropy&cs=srgb&fm=jpg&w=100&q=80',
    status: 'active',
    credits: 60,
    topupCredits: 60,
    refCredits: 0,
    joinedDate: '2026-01-08',
    puzzlesSolved: 11
  },
  {
    id: 'ref6',
    name: 'Sneha Joshi',
    username: '@sneha_j',
    profilePic: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?crop=entropy&cs=srgb&fm=jpg&w=100&q=80',
    status: 'inactive',
    credits: 12,
    topupCredits: 0,
    refCredits: 12,
    joinedDate: '2025-12-30',
    puzzlesSolved: 18
  },
  {
    id: 'ref7',
    name: 'Rohit Pandey',
    username: '@rohit_p',
    profilePic: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?crop=entropy&cs=srgb&fm=jpg&w=100&q=80',
    status: 'inactive',
    credits: 7,
    topupCredits: 0,
    refCredits: 7,
    joinedDate: '2025-12-15',
    puzzlesSolved: 27
  },
  {
    id: 'ref8',
    name: 'Ananya Desai',
    username: '@ananya_d',
    profilePic: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&w=100&q=80',
    status: 'inactive',
    credits: 3,
    topupCredits: 0,
    refCredits: 3,
    joinedDate: '2026-01-09',
    puzzlesSolved: 6
  },
  {
    id: 'ref15',
    name: 'Vivek Reddy',
    username: '@vivek_r',
    profilePic: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&w=100&q=80',
    status: 'inactive',
    credits: 5,
    topupCredits: 0,
    refCredits: 5,
    joinedDate: '2025-12-10',
    puzzlesSolved: 15
  },
  {
    id: 'ref9',
    name: 'Manish Tiwari',
    username: '@manish_t',
    profilePic: 'https://images.unsplash.com/photo-1599566150163-29194dcabd9c?crop=entropy&cs=srgb&fm=jpg&w=100&q=80',
    status: 'inactive',
    credits: 0,
    topupCredits: 0,
    refCredits: 0,
    joinedDate: '2025-12-25',
    puzzlesSolved: 3
  },
  {
    id: 'ref10',
    name: 'Pooja Sharma',
    username: '@pooja_s',
    profilePic: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?crop=entropy&cs=srgb&fm=jpg&w=100&q=80',
    status: 'inactive',
    credits: 0,
    topupCredits: 0,
    refCredits: 0,
    joinedDate: '2026-01-01',
    puzzlesSolved: 1
  },
  {
    id: 'ref11',
    name: 'Suresh Kumar',
    username: '@suresh_k',
    profilePic: 'https://images.unsplash.com/photo-1552058544-f2b08422138a?crop=entropy&cs=srgb&fm=jpg&w=100&q=80',
    status: 'inactive',
    credits: 0,
    topupCredits: 0,
    refCredits: 0,
    joinedDate: '2025-12-18',
    puzzlesSolved: 0
  },
  {
    id: 'ref12',
    name: 'Kavita Nair',
    username: '@kavita_n',
    profilePic: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?crop=entropy&cs=srgb&fm=jpg&w=100&q=80',
    status: 'inactive',
    credits: 0,
    topupCredits: 0,
    refCredits: 0,
    joinedDate: '2026-01-03',
    puzzlesSolved: 2
  },
  {
    id: 'ref13',
    name: 'Rajesh Iyer',
    username: '@rajesh_i',
    profilePic: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&w=100&q=80',
    status: 'inactive',
    credits: 0,
    topupCredits: 0,
    refCredits: 0,
    joinedDate: '2025-12-22',
    puzzlesSolved: 0
  },
  {
    id: 'ref14',
    name: 'Divya Chauhan',
    username: '@divya_c',
    profilePic: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?crop=entropy&cs=srgb&fm=jpg&w=100&q=80',
    status: 'inactive',
    credits: 0,
    topupCredits: 0,
    refCredits: 0,
    joinedDate: '2026-01-06',
    puzzlesSolved: 1
  }
];

export const mockPuzzle = {
  id: 'p1',
  date: '2026-01-11',
  language: 'english',
  question: 'What is the capital of India?',
  options: [
    { id: 'opt1', text: 'Mumbai' },
    { id: 'opt2', text: 'New Delhi' },
    { id: 'opt3', text: 'Bangalore' },
    { id: 'opt4', text: 'Kolkata' }
  ],
  correctAnswer: 'opt2'
};

export const mockPuzzleHinglish = {
  id: 'p1',
  date: '2026-01-11',
  language: 'hinglish',
  question: 'India ki capital kya hai?',
  options: [
    { id: 'opt1', text: 'Mumbai' },
    { id: 'opt2', text: 'New Delhi' },
    { id: 'opt3', text: 'Bangalore' },
    { id: 'opt4', text: 'Kolkata' }
  ],
  correctAnswer: 'opt2'
};

export const mockWithdrawalHistory = [
  {
    id: 'wd1',
    amount: 150,
    date: '2026-01-05',
    status: 'completed',
    method: 'UPI'
  },
  {
    id: 'wd2',
    amount: 200,
    date: '2025-12-28',
    status: 'completed',
    method: 'Bank Transfer'
  },
  {
    id: 'wd3',
    amount: 100,
    date: '2025-12-15',
    status: 'pending',
    method: 'UPI'
  }
];

// Initial state for countdown (resets at 7 PM daily)
export const getTimeUntil7PM = () => {
  const now = new Date();
  const today7PM = new Date();
  today7PM.setHours(19, 0, 0, 0);
  
  if (now > today7PM) {
    // If it's past 7 PM, set to tomorrow 7 PM
    today7PM.setDate(today7PM.getDate() + 1);
  }
  
  const diff = today7PM - now;
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  
  return { hours, minutes, seconds };
};
